export default __webpack_public_path__ + "static/media/36I-114285_-20965_0.33f7313e.jpg";